/* eslint-disable @angular-eslint/component-class-suffix */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ToolsBoxService} from '../../Services/tools.service';


@Component({
    selector: 'tutorials',
    templateUrl: 'tutorials.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class Tutorials implements OnInit {

  seeLeave = true;
  seePassword : boolean;
  seeAddAvatar: boolean;
  seeDelAvatar: boolean;
  seeSocialEvent: boolean;

  constructor(private toolsBoxService: ToolsBoxService,
              private router: Router,
              private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.toolsBoxService.changeHeaderName("Tutorials");
  }

  addLeave(){
    this.seeLeave = true;
    this.seePassword = false;
    this.seeAddAvatar = false;
    this.seeDelAvatar = false;
    this.seeSocialEvent = false;
    this.cdr.markForCheck();
  }

  modifyPassword(){
    this.seeLeave = false;
    this.seePassword = true;
    this.seeAddAvatar = false;
    this.seeDelAvatar = false;
    this.seeSocialEvent = false;
    this.cdr.markForCheck();
  }

  addAvatar(){
    this.seeLeave = false;
    this.seePassword = false;
    this.seeAddAvatar = true;
    this.seeDelAvatar = false;
    this.seeSocialEvent = false;
    this.cdr.markForCheck();
  }

  delAvatar(){
    this.seeLeave = false;
    this.seePassword = false;
    this.seeAddAvatar = false;
    this.seeDelAvatar = true;
    this.seeSocialEvent = false;
    this.cdr.markForCheck();
  }

  socialEvent(){
    this.seeLeave = false;
    this.seePassword = false;
    this.seeAddAvatar = false;
    this.seeDelAvatar = false;
    this.seeSocialEvent = true;
    this.cdr.markForCheck();
  }

}
